import { render, staticRenderFns } from "./TabScoringModelWeights.vue?vue&type=template&id=8d2a4bcc"
import script from "./TabScoringModelWeights.vue?vue&type=script&lang=js"
export * from "./TabScoringModelWeights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports